import type { MergedAccountView } from "@sales-ops-amplify/shared";

export function CompanyEnrichmentTab({
  merged,
  isMutable,
  onEnrich,
  onResearch,
  enriching,
  researching,
  enrichMessage,
  enrichError,
}: {
  merged: MergedAccountView;
  isMutable: boolean;
  onEnrich?: () => void;
  onResearch?: () => void;
  enriching?: boolean;
  researching?: boolean;
  enrichMessage?: string;
  enrichError?: string;
}) {
  const user = merged.user;
  const directory = merged.directory;

  return (
    <div className="space-y-4 rounded-lg border border-border bg-card p-4">
      <h3 className="text-sm font-semibold">Enrichment & research</h3>
      <dl className="grid gap-3 sm:grid-cols-2 text-sm">
        <div>
          <dt className="text-[11px] uppercase text-muted-foreground">
            Last researched
          </dt>
          <dd className="font-medium">
            {user?.lastResearchedAt
              ? new Date(user.lastResearchedAt).toLocaleString()
              : "—"}
          </dd>
        </div>
        <div>
          <dt className="text-[11px] uppercase text-muted-foreground">
            Directory source
          </dt>
          <dd className="font-medium">
            {directory?.dataSource ?? (merged.isSeeded ? "seeded" : "—")}
          </dd>
        </div>
        <div>
          <dt className="text-[11px] uppercase text-muted-foreground">
            Profile updated
          </dt>
          <dd className="font-medium">
            {user?.updatedAt
              ? new Date(user.updatedAt).toLocaleString()
              : directory?.updatedAt
                ? new Date(directory.updatedAt).toLocaleString()
                : "—"}
          </dd>
        </div>
        <div>
          <dt className="text-[11px] uppercase text-muted-foreground">
            Saved copy
          </dt>
          <dd className="font-medium">{user ? "Yes" : "No"}</dd>
        </div>
      </dl>

      {isMutable ? (
        <div className="flex flex-wrap gap-2">
          {onResearch ? (
            <button
              type="button"
              disabled={researching}
              onClick={onResearch}
              className="rounded-md bg-brand px-3 py-2 text-xs font-semibold text-brand-foreground disabled:opacity-50"
            >
              {researching ? "Researching…" : "Research company"}
            </button>
          ) : null}
          {onEnrich ? (
            <button
              type="button"
              disabled={enriching}
              onClick={onEnrich}
              className="rounded-md border border-border px-3 py-2 text-xs font-semibold hover:bg-muted/40 disabled:opacity-50"
            >
              {enriching ? "Enriching…" : "Enrich (Apollo)"}
            </button>
          ) : null}
        </div>
      ) : (
        <p className="text-xs text-muted-foreground">
          Save this company to run research and Apollo enrich on your copy.
        </p>
      )}

      {enrichError ? (
        <p className="text-xs text-destructive">{enrichError}</p>
      ) : null}
      {enrichMessage ? (
        <p className="text-xs text-emerald-600">{enrichMessage}</p>
      ) : null}
    </div>
  );
}
